// extracted by mini-css-extract-plugin
export default {"promptItem":"Paraphrasing_promptItem__HMHs7"};